import { Outlet } from 'react-router-dom'
import { useReferralTypesLayout } from 'app/components/referral-types-layout/useReferralTypesLayout'
import { ReferralTypesLayoutComponent } from 'app/components/referral-types-layout/ReferralTypesLayoutComponent'

export default function ReferralTypesLayout(): React.ReactElement {
  const { title, tabs } = useReferralTypesLayout()

  return (
    <ReferralTypesLayoutComponent title={title} tabs={tabs}>
      <Outlet />
    </ReferralTypesLayoutComponent>
  )
}
